"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetAnnotationResultSerializedSchema = void 0;
const zod_1 = require("zod");
const AnalysisType_1 = require("../AnalysisRequirements/AnalysisType");
const ISerializedNetAnnotations_1 = require("./ISerializedNetAnnotations");
exports.NetAnnotationResultSerializedSchema = zod_1.default.object({
    type: zod_1.default.literal(AnalysisType_1.AnalysisType.NetAnnotation),
    result: ISerializedNetAnnotations_1.ISerializedNetAnnotationsSchema,
});
//# sourceMappingURL=NetAnnotationResultSerialized.js.map